import Vue from 'vue'
// Element UI 按需引入：只注册项目实际用到的组件。
// 组件清单由 work/inventory-element-ui.cjs 扫源码得出；**新增 el-* 用法时必须在这里补一行**，
// 否则该组件运行时「不认识」而整页报错（编译期不会报错，务必留意）。
import {
  Alert, Aside, Badge, Button, Card, Checkbox, CheckboxGroup, Collapse, CollapseItem,
  Container, DatePicker, Descriptions, DescriptionsItem, Dialog, Drawer, Empty, Form,
  FormItem, Header, Image, Input, InputNumber, Main, Menu, MenuItem, Option, OptionGroup,
  Pagination, Select, Submenu, Switch, TabPane, Table, TableColumn, Tabs, Tag, Timeline,
  TimelineItem, Tooltip, Upload,
  // 非标签式：指令与服务必须显式注册
  Loading, Message, MessageBox,
} from 'element-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/base.scss'

Vue.config.productionTip = false

const registered = [
  Alert, Aside, Badge, Button, Card, Checkbox, CheckboxGroup, Collapse, CollapseItem,
  Container, DatePicker, Descriptions, DescriptionsItem, Dialog, Drawer, Empty, Form,
  FormItem, Header, Image, Input, InputNumber, Main, Menu, MenuItem, Option, OptionGroup,
  Pagination, Select, Submenu, Switch, TabPane, Table, TableColumn, Tabs, Tag, Timeline,
  TimelineItem, Tooltip, Upload,
]
registered.forEach((component) => Vue.use(component))

// v-loading 与 $message / $confirm / $prompt 在模板与代码里都在用
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
